import React from "react";
import { Card, Col, Row, Typography } from "antd";
import { LineChartOutlined } from "@ant-design/icons";

const { Paragraph, Text, Title } = Typography;

const MarketReferenceHeader = () => {
    return (
        <Card
            size="small"
            style={{
                marginBottom: 16,
                borderColor: "#b7d6d6",
                background: "linear-gradient(135deg, #f3fbfb 0%, #e8f4f4 100%)",
            }}
        >
            <Row gutter={[24, 16]} align="middle">
                <Col flex="auto">
                    <Title level={4} style={{ margin: 0 }}>
                        <LineChartOutlined style={{ marginRight: 8, color: "#006d75" }} />
                        市场参考价管理
                    </Title>
                    <Paragraph type="secondary" style={{ margin: "8px 0 0" }}>
                        当前只落 Source / Series / Daily Quote 骨架与浏览能力，先把上游事实层建稳，再进入导入与自动算价链路。
                    </Paragraph>
                </Col>
                <Col>
                    <Text strong style={{ color: "#006d75" }}>
                        多来源 + 多曲线 + 动态字段 schema
                    </Text>
                </Col>
            </Row>
        </Card>
    );
};

export default MarketReferenceHeader;
